<div *nzModalTitle>
  <div class="modal-title">Сессия скоро закончится</div>
</div>
<div class="modal">
  <div class="modal__body">
    <p>До завершения сессии осталось: {{ time }} c</p>
  </div>

  <div class="modal__footer">
    <ui-button (click)="destroyModal()">Завершить сессию</ui-button>
    <ui-button (click)="submit()">Продолжить сессию</ui-button>
  </div>
</div>
